<template>
    <div class="col-md-6 col-sm-12">
        <div class="featured-localization" v-on:click="$emit('selected', localization)">
            <div class="featured-localization__icon">
                <svg width="22px" height="40px" viewBox="0 0 22 40" version="1.1" xmlns="http://www.w3.org/2000/svg">
                    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <g id="design_Kontakt" transform="translate(-1243.000000, -370.000000)">
                            <g id="google_maps_pin_inactive" transform="translate(1243.000000, 370.000000)">
                                <path class="wch-svg-color" d="M11,0.5 C13.8994949,0.5 16.5244949,1.67525253 18.4246212,3.5753788 C20.3247475,5.47550506 21.5,8.10050506 21.5,11 C21.5,13.1439443 20.8575708,15.1378752 19.7495688,16.8070372 C18.0857774,19.412925 14.3659648,25.4734267 13.1606259,28.9962495 C12.1985375,31.808128 11.5441681,35.6153179 11.1969512,38.01314 L11.1969512,38.01314 L11.1969512,39.5 L10.7534547,38.01314 C10.4062378,35.6153179 9.7518683,31.808128 8.78977997,28.9962495 C7.57569869,25.4478756 3.86576741,19.3569132 2.45784347,17.1089014 C1.21884358,15.3677757 0.5,13.2678178 0.5,11 C0.5,8.10050506 1.67525253,5.47550506 3.5753788,3.5753788 C5.47550506,1.67525253 8.10050506,0.5 11,0.5 Z" id="pin" stroke="#002C5C"
                                      :fill="active ? '#fdb913' : '#ffffff'"></path>
                                <path d="M11,16 C13.209139,16 15,14.209139 15,12 C15,9.790861 13.209139,8 11,8 C8.790861,8 7,9.790861 7,12 C7,14.209139 8.790861,16 11,16 Z" id="circle" fill="#002C5C"></path>
                            </g>
                        </g>
                    </g>
                </svg>
            </div>
            <div class="featured-localization__info">
                <div class="featured-localization__info--small"
                     v-if="localization['media-type']"
                >
                    <span v-for="type of localization['media-type']">
                        {{type['name']}}
                    </span>
                </div>

                <p>{{localization['short_name']}}</p>
                <p v-for="line of localization['localization_address']">{{line['localization_address_line']}}</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Localization",
    props: ["localization", "active"]
}
</script>

<style scoped lang="scss">
@import "./assets/styles/base/variables";

.featured-localization {
    display: flex;
    margin-bottom: 17px;

    &__icon {
        margin-right: 10px;
        margin-top: 22px;

        @media (min-width: map-get($grid-breakpoints, "xl")) {
            margin-top: 16px;
        }

        svg {
            height: 22px;
            width: 13px;
            @media (min-width: map-get($grid-breakpoints, "xl")) {
                height: 40px;
            }
        }
    }

    &__info {
        cursor: pointer;

        &--small {
            opacity: 0.47;
            color: $white;
            font-size: 13px;
            letter-spacing: 0;
            line-height: 24px;
            text-transform: uppercase;
            margin-bottom: 1px;
        }

        p {
            color: $white;
            font-size: 18px;
            font-weight: 600;
            letter-spacing: 0;
            line-height: 1;
            @media (min-width: map-get($grid-breakpoints, "xl")) {
                font-size: 18px;
            }
        }
    }
}
</style>
